export default __webpack_public_path__ + "media/images/screen_hello-1a8a513d829faf426fd2c6dc01ca79eb.svg";